<template>
  <div>
    <view-table
        ref="viewTable"
        :filter="filter"
        :limits="limits"
        :columns-property="columnsProperty"
        module="basic"
        url="inspectionReports/pp1"
        @select="selectHandle"
        @delete="deleteHandle"
        @reset="resetHandle"
        @addOrEdit="addEditHandle">
      <template slot="adSearch">
        <el-form :inline="true" :model="filter" @submit.native.prevent @keyup.enter.native="loadData(1)">
          <el-form-item label="编号">
            <el-input v-model.trim="filter.no" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="关联单据">
            <el-input v-model.trim="filter.refBillNo" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="状态">
            <el-select v-model="filter.status" clearable>
              <el-option label="草稿" :value="0"/>
              <el-option label="已提交" :value="20"/>
            </el-select>
          </el-form-item>
          <el-form-item label="物料编号">
            <el-input v-model.trim="filter.materialNo" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="物料名称">
            <el-input v-model.trim="filter.materialName" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="规格型号">
            <el-input v-model.trim="filter.specification" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="制单人">
            <el-input v-model.trim="filter.creatorName" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="创建日期">
            <el-date-picker
                v-model="createDateRange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                value-format="yyyy-MM-dd"
                @change="dateRangeChange('createDateRange', 'startCreateDate', 'endCreateDate')"/>
          </el-form-item>
        </el-form>
      </template>
      <template slot="actionBtn" slot-scope="scope">
        <el-button
            v-if="addAuth"
            type="primary"
            :disabled="scope.row.status !== 0"
            @click="submitHandle(scope.row)">
          提交
        </el-button>
      </template>
    </view-table>
    <!-- 编辑 -->
    <inspection-report-edit ref="inspectionReportEdit" @save-success="loadData"/>
  </div>
</template>

<script>
  import ViewTable from "@/components/ViewTable.vue";
  import InspectionReportEdit from "./InspectionReportEdit1";

  export default {
    name: "InspectionReportList1",
    components: {
      ViewTable,
      InspectionReportEdit,
    },
    data() {
      return {
        limits: {
          detailAuth: this.$auth(528),
          editAuth: this.$auth(530),
          // addAuth: this.$auth(529),
          // delAuth: this.$auth(531),
        },
        addAuth: this.$auth(529),
        importLoading: false,
        mainBoxHeight: 0,
        data: [],
        createDateRange: [],
        filterText: "",
        filter: {
          no: "",
          refBillNo: "",
          billType: -1,
          materialNo: "",
          materialName: "",
          specification: "",
          creatorName: "",
          status: "",
          startCreateDate: "",
          endCreateDate: "",
        },
        columnsProperty: [
          {
            key: "no",
            align: "center",
            render: (h, params) => {
              return h(
                  "span",
                  {
                    style: {
                      color: "#2d8cf0",
                      cursor: "pointer",
                    },
                    on: {
                      click: () => {
                        this.$refs.inspectionReportEdit.open(params.row, true, true);
                      },
                    },
                  },
                  params.row.no,
              );
            },
          },
          {
            key: "name",
            align: "center",
          },
          {
            key: "action",
            align: "center",
            width: 140,
            slot: "action",
            fixed: "right",
          },
        ],
        selection: [],
      };
    },
    watch: {
      "filter.startCreateDate": {
        handler(newVal) {
          if (newVal) {
            this.createDateRange = [];
            this.createDateRange.push(this.filter.startCreateDate);
            this.createDateRange.push(this.filter.endCreateDate);
          }
        },
      },
    },

    methods: {
      dateRangeChange(timeRange, timeStart, timeEnd) {
        if (this[timeRange]) {
          this.filter[timeStart] = this[timeRange][0];
          this.filter[timeEnd] = this[timeRange][1];
        } else {
          this.filter[timeStart] = "";
          this.filter[timeEnd] = "";
        }
      },
      addEditHandle(row) {
        this.$refs.inspectionReportEdit.open(row, true, false);
      },

      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },

      // 删除(单删、多删)
      deleteHandle(row) {
        this.$http.delete("basic", "inspectionReports", row.pkId).then((res) => {
          if (res.success) {
            this.loadData();
            this.$message.success("删除成功");
          }
        });
      },
      submitHandle(row) {
        this.$confirm("确定提交吗?", "提示", {type: "warning"}).then(() => {
          this.$http.post("basic", "inspectionReports/submit/" + row.pkId).then(() => {
            this.loadData(1);
            this.$message.success("提交成功");
            this.selection = [];
          });
        });
      },
      // checkBox
      selectHandle(selection) {
        this.selection = selection;
      },
      // 重置
      resetHandle(filter) {
        this.filter = Object.assign(this.filter, filter);
      },
      // 未提交、退单可以编辑删除
      otherAuth(row) {
        if (row.status === 0) {
          return {
            editAuth: false,
            delAuth: false,
          };
        } else {
          return {
            editAuth: true,
            delAuth: true,
          };
        }
      },
    },
  };
</script>
<style scoped>
</style>

<style>
</style>
